import { CollectionApi } from 'api';
import { useAuthMutation, useQueryClient } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';

function useCreate() {
  const queryClient = useQueryClient();
  return useAuthMutation(CollectionApi.post, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getQueryKeys(KEY).lists(),
      });
    },
  });
}

export default useCreate;
